/*
 *
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT-0
 */
import { useEffect, useState } from 'react';
import { DemoDefinition } from '../types';
import App from '../App';
import { DemoContext } from './demo-context';
import { useAuth } from 'react-oidc-context';
import { getEndpoint } from '../utils';


export default function AppConfigured() {
  const [demos, setDemos] = useState<DemoDefinition[]>([]);
  const auth = useAuth();
  useEffect(() => {
    (async () => {
      if (auth.isAuthenticated) {
        document.cookie = `auth_token=${auth.user?.access_token}; path=/; secure; samesite=strict`;
        window.history.replaceState({},
          window.document.title,
          window.location.origin + window.location.pathname);
        try {
          auth.startSilentRenew();
          const token = auth.user?.id_token;
          const endpoint = getEndpoint('/api/demos');
          if (!token) {
            return;
          }
          localStorage.setItem('token', token);
          fetch(endpoint, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          }).then((response) => {
            if (!response.ok) {
              response.text().then((t) => console.error(t));

            } else {
              response.json().then((data) => {
                setDemos(data);
              })
            }
          }).catch((e) => {
            console.error(e);
          });
        } catch (e) {
          setDemos([]);
          console.error(e);
        }
      } else {
        setDemos([]);
      }
    })().catch((e) => {
      console.error(e);
    });
  }, [auth]);


  // if (demos.length === 0) {
  //   return (
  //     <div>Loading...</div>
  //   )
  // }

  return (
    <DemoContext.Provider value={demos}>
      <App />
    </DemoContext.Provider>
  );
}
